import type { FunctionComponent, PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

import { route as dashboardPageRoute } from '../pages/dashboard/constants';
import { route as dashboardV2Route } from '../pages/dashboard-v2/constants';
import { useDashboardVisibility } from './use-dashboard-visibility';

type DashboardAccessGuardProperties = {
    readonly dashboard: 'new' | 'talent';
};

export const DashboardAccessGuard: FunctionComponent<PropsWithChildren<DashboardAccessGuardProperties>> = ({
    children,
    dashboard,
}) => {
    const visibility = useDashboardVisibility();

    if (visibility.isNothing) {
        return null;
    }

    const { canSeeNewDashboard, canSeeTalentDashboard } = visibility.value;
    const isAllowed = dashboard === 'new' ? canSeeNewDashboard : canSeeTalentDashboard;

    if (isAllowed) {
        return children;
    }

    return (
        <Navigate
            replace={true}
            to={dashboard === 'new' ? dashboardPageRoute.patterns.dashboard : dashboardV2Route.patterns.dashboardV2}
        />
    );
};
